import React from "react";
import Sidebar from "../Sidebar";
import { useSelector } from "react-redux";

/**
 * HeaderV2
 *
 * @param {object} props
 * @param {string} [props.header]
 * @param {React.ReactNode} [props.leftButton]
 * @param {React.ReactNode} [props.rightButton]
 * @returns {JSX.Element}
 */
const HeaderNoLogo = ({ header, leftButton, rightButton }) => {
  const isSidebarOpened = useSelector((state) => state.mainSlice.isSidebarOpened);

  return (
    <header className={`header header-background`}>
      <section>
        <div className={`content-section ${header ? "content-section-align-bottom" : "content-section-align-center"}`}>
          <div className="header-flex">
            {/* <div
              className="burger_menu"
              onClick={() => toggleSidebar(!isSidebarOpen)}
            >
              <img src={BurgerMenu} alt="burger menu" />
            </div> */}

            {leftButton || <div className="empty-icon"></div>}
          </div>

          <div className="header-flex">
            {header ? (
              <>
                <div className="logo-with-header">
                  <div className="header-text">{header}</div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>

          <div className="header-flex">{rightButton || <div className="empty-icon"></div>}</div>
        </div>
      </section>
      {isSidebarOpened ? <Sidebar /> : ""}
    </header>
  );
};

export default HeaderNoLogo;
